import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { adminApiClient } from "../../lib/adminApiClient";
import { queryKeys } from "../../lib/queryClient";
import { ErrorBanner, LoadingState } from "../../components/States";
import { formatDateTime } from "../../lib/format";

export function AdminUsersPage() {
  const [search, setSearch] = useState("");
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.adminUsers(search),
    queryFn: () => adminApiClient.listUsers({ limit: 50, search: search || undefined }),
  });

  return (
    <div className="stack">
      <h1>Users</h1>
      <div className="field" style={{ maxWidth: 320 }}>
        <label htmlFor="user-search">Search by username or email</label>
        <input
          id="user-search"
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {isLoading && <LoadingState label="Loading users…" />}
      {isError && <ErrorBanner error={error} onRetry={() => void refetch()} />}

      {data && (
        <div style={{ overflowX: "auto" }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Email</th>
                <th>Status</th>
                <th>Role</th>
                <th>Listings</th>
                <th>Buyer orders</th>
                <th>Seller orders</th>
                <th>Joined</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((u) => (
                <tr key={u.id}>
                  <td>
                    <Link to={`/admin/users/${u.id}`}>{u.username ?? u.id.slice(0, 8)}</Link>
                  </td>
                  <td>{u.email ?? "—"}</td>
                  <td>
                    <span className={u.status === "SUSPENDED" ? "badge badge--danger" : "badge badge--success"}>
                      {u.status}
                    </span>
                  </td>
                  <td>{u.role}</td>
                  <td>{u.listingCount}</td>
                  <td>{u.buyerOrderCount}</td>
                  <td>{u.sellerOrderCount}</td>
                  <td>{formatDateTime(u.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.items.length === 0 && <p className="muted">No users found.</p>}
        </div>
      )}
    </div>
  );
}
